import { registerPlugin } from '@capacitor/core';
const TestFlightDetect = registerPlugin('TestFlightDetect', {
    web: () => import('./web').then(m => new m.TestFlightDetectWeb()),
});
export * from './definitions';
export { TestFlightDetect };
//# sourceMappingURL=index.js.map